import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const ModalBody = styled.div`
  align-items: center;
  background-color: var(--color-components-modal-body-bg);
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: center;
`;

const ModalImage = styled.div`
  margin-bottom: 8px;
  max-height: 240px;
`;

const ModalContentText = styled(Typography)`
  margin-top:
  max-width: 100%;
  text-align: center;
  word-break: break-word; ;
`;

const ModalCustomContent = styled.div`
  width: 100%;
`;

const NotificationProvider = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const NotificationFormInputOptions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1.6rem;
  justify-content: flex-start;
  margin-left: 0.4rem;
  margin-top: 0.8rem;
  width: 100%;

  label {
    white-space: nowrap;
  }
`;

const NotificationFormInput = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

const NotificationForm = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export {
  ModalBody,
  ModalContentText,
  ModalCustomContent,
  ModalImage,
  NotificationForm,
  NotificationFormInput,
  NotificationFormInputOptions,
  NotificationProvider
};
